import React from 'react';
import {
  Affix, Steps, Form, Spin, Typography, Alert,
} from 'antd';
import { useTranslation } from 'react-i18next';

import MainLayout from '@common/layouts/MainLayout';
import withAuth from '@common/hocs/withAuth';
import Breadcrumb from '@common/containers/Breadcrumb';
import CenteredContent from '@common/components/ui/CenteredContent';

import useDevicesEditCreate from './useDevicesEditCreate';
import styles from './DevicesEditCreate.module.less';

import GeneralAlarma from './containers/GeneralAlarma';
import CondicionesAlarma from './containers/CondicionesAlarma';
import AccionesAlarma from './containers/AccionesAlarma';

const { Step } = Steps;
const { Paragraph } = Typography;

function DevicesEditCreate() {

  const { t } = useTranslation();
  const {
    breadcrumbData,
    container,
    setContainer,
    form,
    formOnValuesChange,
    loadingAlarmToEdit,
    createEditValues,
    currentStep,
    onNext,
    onPrevious,
    onSave,
    saveLoading,
    isEditDefault,
    businessData,
    alarm_id
  } = useDevicesEditCreate();

  return (
    <MainLayout applyPadding={false}>
      <div className={styles.container} ref={setContainer}>
        <Affix target={() => container}>
          <Breadcrumb breadcrumbData={breadcrumbData} />
        </Affix>

        <div className={styles.main_content}>
          {isEditDefault && (
            <Alert
              className={styles.default_alert}
              type="info"
              message={t(
                'views.dynamic_alarms_create_edit.feedbacks.only_actions_for_default_alarms',
              )}
            />
          )}

          <Steps className={styles.steps} current={currentStep}>
            <Step title={t('views.dynamic_alarms_create_edit.steps.general_info')} />
            <Step title={t('views.dynamic_alarms_create_edit.steps.conditionals')} />
            <Step title={t('views.dynamic_alarms_create_edit.steps.actions')} />
          </Steps>

          {loadingAlarmToEdit && (
            <CenteredContent padding="50px 0">
              <Spin size="large" />
              <Paragraph style={{ marginBottom: 0, marginTop: 20 }}>
                {t('views.dynamic_alarms_create_edit.feedbacks.loading')}
              </Paragraph>
            </CenteredContent>
          )}

          {createEditValues && (
            <Form
              layout="vertical"
              form={form}
              initialValues={createEditValues}
              onValuesChange={formOnValuesChange}
            >
              <div style={{ display: currentStep === 0 ? 'block' : 'none' }}>
                <GeneralAlarma onNext={onNext} businessData={businessData} alarm_id={alarm_id} />
              </div>

              <div style={{ display: currentStep === 1 ? 'block' : 'none' }}>
                <CondicionesAlarma form={form} onPrevious={onPrevious} onNext={onNext} />
              </div>

              <div style={{ display: currentStep === 2 ? 'block' : 'none' }}>
                <AccionesAlarma
                  form={form}
                  onPrevious={onPrevious}
                  onSave={onSave}
                  saveLoading={saveLoading}
                />
              </div>
            </Form>
          )}
        </div>
      </div>
    </MainLayout>
  );

}

export default withAuth(DevicesEditCreate);
